var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgInvisible = function SvgInvisible(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 1000 1000",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M994.6 482.3c-8.3-12.1-183.4-319.8-494.6-319.8S13.6 470.3 5.3 482.3c-7.1 10.4-7.1 23.2.1 33.5 8.4 12 185.9 321.7 494.6 321.7 305.7 0 486.2-309.8 494.7-321.7 7.1-10.2 7.1-23.2-.1-33.5m-97.2 28.2c-57.7 69-191.2 258.2-397.4 258.2-206.3 0-339.8-189.2-397.5-258.3L93 498.8l9.5-11.4c57.3-68.9 189.9-256.1 397.5-256.1 206.4 0 339.8 187.1 397.5 256.2L907 499z",
    className: "invisible_svg__invisible0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 500,
    cy: 500,
    r: 137.2,
    className: "invisible_svg__invisible0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M164.7 908.1c-10.4 0-20-4-27.4-11.3l-34.1-34.1c-15.1-15.1-15.1-39.6 0-54.7L808 103.2c7.3-7.3 17-11.3 27.4-11.3s20 4 27.4 11.3l34.1 34.1c7.3 7.3 11.3 17 11.3 27.4s-4 20-11.3 27.4L192 896.8c-7.3 7.3-17 11.3-27.3 11.3",
    className: "invisible_svg__invisible0"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgInvisible);
export default ForwardRef;